export default __webpack_public_path__ + "static/media/Artboard 20.5161a843.png";